import React from 'react';
import {RaisedButton, Snackbar} from "material-ui";
import {Link, withRouter} from "react-router-dom";
import {trim, get, isEmpty, isNull} from "lodash";
import {validateEmail} from "../helpers";
import {partnerEnquiryForm} from "../actions/lead";
import {connect} from "react-redux";
import JdData from './JdData'

class PartnerWithUs extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false
        }
    }
    state = {
        name : '',
        email : '',
        mobile : '',
        location : '',
        enquiryMessage : '',
        disabled : false
    }
    
    onSubmit = async (e) => {
        e.preventDefault();
        if (await this.validate()) {
            this.setState({disabled : true})
            const body = {
                name : this.state.name,
                email : this.state.email,
                mobile : this.state.mobile,
                location : this.state.location,
                enquiry_message : this.state.enquiryMessage
            };
            this.setState({disabled: true});
            const res = await this.props.savePartnerEnquiryForm(body);
            if (res) {
                this.setState({
                    snackOpen: true,
                    email: '',
                    disabled : false,
                    name : '',
                    mobile : '',
                    location : '',
                    enquiryMessage : ''
                });
            } else {
                alert('Something Went Wrong.');
            }
        }
    }

    onInputChange = (e, key) => {
        const inputValue = e.target.value
        if(key === 'mobile'){
            if (/^\d{0,10}$/.test(inputValue)) {
                this.setState({ mobile: inputValue });
            }
        } else {
            this.setState({
                [key]: inputValue
            });
        }
    }

    validate = async () => {
        let validateFlag = true;
        if (!validateEmail(this.state.email)) {
            validateFlag = false;
            this.setState({
                emailError: alert(`Not a valid Email`)
            });
        } else {
            this.setState({
                emailError: ''
            });
        }
        if (isEmpty(this.state.name)) {
            validateFlag = false;
            this.setState({
                nameError:`Name is required`
            });
        } else {
            this.setState({
                nameError: ''
            });
        }
        if (isEmpty(this.state.mobile) || isNull(this.state.mobile)) {
            validateFlag = false;
            this.setState({
                mobileError: `Mobile is required`
            });
        } else {
            this.setState({
                mobileError: ''
            });
        }
        if (!isEmpty(this.state.mobile)) {
            if(this.state.mobile.length > 10){
                validateFlag = false;
                this.setState({
                    mobileError: `Mobile should be 10 digit only`
                });
            } else {
                this.setState({
                    mobileError: ''
                });
            }
        }
        if (isEmpty(this.state.location)) {
            validateFlag = false;
            this.setState({
                locationError: `Loaction is required`
            });
        } else {
            this.setState({
                locationError: ''
            });
        }
        return validateFlag;
    }

    render() {
        return (
            <div className="container">
                <div className='partner_section'>
                    <div style={{display:'flex', flexDirection:'column'}}>
                        <div style={{display:'flex'}}>
                            <p style={{fontSize:24, fontWeight:'bold', marginBlock:0, color:'#925a94'}}>Partner with us</p>
                        </div>
                        <div style={{display:'flex'}}>
                            <p className='partner_text'>
                            Ascend to new heights with Ascend Capital:<br/>Your trusted partner for EV financing solutions.
                            </p>
                        </div>
                    </div>
                    <div style={{display:'flex', flexDirection:'column'}}>
                        <div style={{display:'flex', flexDirection:'row', alignItems:'center'}}>
                            <svg className='icon_style' color='#925a94' xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-ev-station" viewBox="0 0 16 16">
                                <path d="M3.5 2a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5zm2.131 10.46H4.14v-.893h1.403v-.505H4.14v-.855h1.49v-.54H3.485V13h2.146zm1.316.54h.794l1.106-3.333h-.733l-.74 2.615h-.031l-.747-2.615h-.764z"/>
                                <path d="M3 0a2 2 0 0 0-2 2v13H.5a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1H11v-4a1 1 0 0 1 1 1v.5a1.5 1.5 0 0 0 3 0V4a.5.5 0 0 0-.146-.354l-.5-.5a.5.5 0 0 0-.707 0l-.5.5A.5.5 0 0 0 13 4v3c0 .71.38 1.096.636 1.357l.007.008c.253.258.357.377.357.635v3.5a.5.5 0 1 1-1 0V12a2 2 0 0 0-2-2V2a2 2 0 0 0-2-2zm7 2v13H2V2a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1"/>
                            </svg>
                            <p className='partner_text_1'><b>50+</b> OEM Tieups</p>
                        </div>
                        <div style={{display:'flex', flexDirection:'row', alignItems:'center', marginTop:20}}>
                            <svg className='icon_style' color='#925a94' xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-people-fill" viewBox="0 0 16 16">
                                <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5.784 6A2.24 2.24 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.3 6.3 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1zM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"/>
                            </svg>
                            <p className='partner_text_1'><b>500+</b> Dealer Network</p>
                        </div>
                    </div>
                </div>
                {/* why choose us section */}
                <div className='partner_section seperator'>
                    <div className='choose_us_get_touch_container'>
                        <div style={{display:'flex', width:'100%', justifyContent:'flex-start'}}>
                            <p style={{fontSize:24, fontWeight:'bold', marginBlock:0, color:'#925a94', marginBottom:'20px'}}>Why choose us</p>
                        </div>
                        <div className='choose_us_container'>
                            <p className='choose_us_text'><b>Quick</b> - Get your funds fast with our expedited loan disbursement process.</p>
                            <p className='choose_us_text'><b>Transparent</b> - Rest assured, our financing plans come with complete transparency, free from any hidden fees.</p>
                            <p className='choose_us_text'><b>Delivery order</b> - Our issuance of delivery orders to customers is advantageous for dealers, facilitating smoother transactions.</p>
                            <p className='choose_us_text'><b>Customer support</b> -  Providing unparalleled assistance, we're committed to ensuring your experience is nothing short of exceptional.</p>
                        </div>
                        <div style={{display:'flex', width:'100%', alignItems:'flex-start'}}>
                            <p style={{fontSize:24, fontWeight:'bold', marginBlock:0, color:'#925a94'}}>Reach us at</p>
                        </div>
                        <div style={{display:'flex', width:'100%', flexDirection:'column',marginTop:20, alignItems:'flex-start'}}>
                            <p className='choose_us_text'><b>+91-9001772907</b> </p>
                            <p className='choose_us_text'>info@ascendcap.in</p>
                        </div>
                    </div>
                    <div className='choose_us_get_touch_container'>
                        <div className='touch_us_form'>
                            <div className='touch_form_header'>
                                <span className='touch_form_label'>Get in Touch</span>
                                <h3 className='touch_form_title'>Partner With Us</h3>
                            </div>

                            <div className='touch_form_row'>
                                <div className='touch_form_field'>
                                    <input
                                        value={this.state.name}
                                        onChange={(e) => this.onInputChange(e, 'name')}
                                        placeholder='Full Name'
                                        className='touch_input'
                                    />
                                    {!isEmpty(this.state.nameError) && <span className='touch_error'>{this.state.nameError}</span>}
                                </div>
                                <div className='touch_form_field'>
                                    <input
                                        type='number'
                                        value={this.state.mobile}
                                        onChange={(e) => this.onInputChange(e, 'mobile')}
                                        placeholder='Mobile Number'
                                        className='touch_input'
                                    />
                                    {!isEmpty(this.state.mobileError) && <span className='touch_error'>{this.state.mobileError}</span>}
                                </div>
                            </div>

                            <div className='touch_form_row'>
                                <div className='touch_form_field'>
                                    <input
                                        value={this.state.email}
                                        onChange={(e) => this.onInputChange(e, 'email')}
                                        placeholder='Email Address'
                                        className='touch_input'
                                    />
                                    {!isEmpty(this.state.emailError) && <span className='touch_error'>{this.state.emailError}</span>}
                                </div>
                                <div className='touch_form_field'>
                                    <input
                                        value={this.state.location}
                                        onChange={(e) => this.onInputChange(e, 'location')}
                                        placeholder='City / Location'
                                        className='touch_input'
                                    />
                                    {!isEmpty(this.state.locationError) && <span className='touch_error'>{this.state.locationError}</span>}
                                </div>
                            </div>

                            <div className='touch_form_field' style={{marginTop: 4}}>
                                <textarea
                                    value={this.state.enquiryMessage}
                                    onChange={(e) => this.onInputChange(e, 'enquiryMessage')}
                                    placeholder='Your message or enquiry...'
                                    className='touch_textarea'
                                    rows={4}
                                />
                            </div>

                            <button
                                disabled={this.state.disabled}
                                onClick={(e) => this.onSubmit(e)}
                                type="submit"
                                className='touch_submit'
                            >
                                Send Message
                            </button>

                            <Snackbar
                                open={this.state.snackOpen}
                                message='Thank you! We will get back to you shortly.'
                                autoHideDuration={4000}
                                onRequestClose={this.onHandleRequestClose}
                            />
                        </div>
                    </div>
                </div>
            <div style={{marginTop:60}}></div>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    savePartnerEnquiryForm: body => dispatch(partnerEnquiryForm(body)),
});

export default withRouter(connect(null, mapDispatchToProps)(PartnerWithUs))


// WEBPACK FOOTER //
// ./src/components/PartnerWithUs.js